
<div class="d-flex justify-space-between">
  <div class="welcome-message line-34" v-html="$t('messages.welcomeMessage', { userName: userName })"></div>
  <div>
    <v-btn fab elevation="0" disabled outlined color="white" class="logo-btn">
      <v-icon class="header-logo"></v-icon>
    </v-btn>
  </div>
</div>
